import { formatCount, wakeUpApp } from '@utils/tools';
import { genTemplatePageSchema } from '@utils/schema';
import cutPic from '../../assets/usage.svg';
import likePic from '../../assets/like.svg';
import Author from '../Author';
import cls from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { Template } from '@typings/template';
import style from './style.scss';

interface Props {
  element: Template;
}

export default function Card(props: Props) {
  const { element } = props;
  const goDetail = useCallback(() => {
    const link = genTemplatePageSchema({
      template_id: element.web_id,
      root_category: '',
      tab_name: '',
    });
    wakeUpApp(link);
  }, []);
  return (
    <div className={cls(style.card, 'template-card')}>
      <div className={style.cover} onClick={goDetail}>
        <img className={style.pic} src={element.cover_url} />
        <div className={cls(style.info)}>
          <img src={cutPic} className={style.usage} />
          <span className={style.count}>{formatCount(element.usage_amount)}</span>
          <img src={likePic} className={style.like} />
          <span className={style.count}>{formatCount(element.like_count)}</span>
        </div>
      </div>
      <div className={cls('template-info', style.extra)}>
        <span className={cls(style.short_title)}>{element.short_title}</span>
        <span className={style.title}>{element.title}</span>
        <Author user={element.author} />
      </div>
    </div>
  );
}
